module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI2OWYwNjJkZTcwOTQ5OWE5YTU2NGNlZmE2NTFmZjJmZi5zdmciOw=="